import type { IBaseViewModel } from '@/engine/app/interfaces';
import { createValueAlgorithmBuilder } from '@/engine/PlanningAlgorithm/CustomMeasurementsAlgorithmBuilders';
import type { IIndicationAdder, IIndicationVMAdder } from '../interfaces';
import type { PlanningAlgorithm } from '@/engine/PlanningAlgorithm/PlanningAlgorithm';
import type { IValue } from '@/engine/DataFlow/Graph';

export class BaseIndicationAdder implements IIndicationAdder<IValue> {
  private readonly _planningAlgorithm: PlanningAlgorithm;

  private readonly _indicationsVMAdder: IIndicationVMAdder;

  public constructor(planningAlgorithm: PlanningAlgorithm, indicationVMAdder: IIndicationVMAdder) {
    this._planningAlgorithm = planningAlgorithm;
    this._indicationsVMAdder = indicationVMAdder;
  }

  public async addIndication(model: IValue, viewModel: IBaseViewModel): Promise<void> {
    await this._planningAlgorithm.extendAlgorithmAsync(
      createValueAlgorithmBuilder(viewModel.descriptor, model),
      viewModel.descriptor
    );

    this._indicationsVMAdder.addObjectViewModelToViews(viewModel);
  }
}
